import type { Profil } from './auth'

/**
 * 92,6 % der Konten sind anonym und haben weder Namen noch Bild. Dann steht
 * dort „Anonym" plus die gekürzte UID.
 *
 * Es wird **nichts erfunden** — kein Platzhaltername, keine Initialen aus der
 * UID. Ein erfundener Name wäre eine Behauptung über einen Menschen (§6.1).
 */
export function anzeigename(profil: Profil | null, uid: string): string {
  return profil?.username ?? profil?.display_name ?? `Anonym · ${uid.slice(0, 6)}`
}

/** Ob wir überhaupt einen echten Namen kennen. */
export function hatNamen(profil: Profil | null): boolean {
  return Boolean(profil?.username ?? profil?.display_name)
}
